module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_02-23301cfe47bfc5d6445fc3c490b93654.jpg";